import React from 'react';
import style from './componentCss/ZigZagContainer.module.css';
import { useTranslation } from 'react-i18next';

function ZigZagContainer({ children }) {
    const { t } = useTranslation();

    return (
        <div className={style.zzcontainer}>
            <div className={style.glassBgGlow}></div>

            <h2 className={style.sectionTitle}>{t('AboutUs.Title')}</h2>
            <div className={style.sectionBar}></div>

            <div className={style.cardsWrapper}>
                {React.Children.map(children, (child, i) => (
                    <div className={style.container__first} key={i}>
                        {React.isValidElement(child)
                            ? (() => {
                                const hasFlipProp = child.props && Object.prototype.hasOwnProperty.call(child.props, 'flip');
                                const desiredFlip = hasFlipProp ? child.props.flip : (i % 2 === 1);
                                return React.cloneElement(child, { flip: desiredFlip });
                              })()
                            : child}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ZigZagContainer;
